/**
 * ADR-0013 — Cashflow / Liquidität Owner (Finance).
 *
 * Kanal-Treasury (Manager/Reports/Bilan): dieses Modul.
 * Schicht / Kasse / Session-Soll: sessionCashflow.js
 *
 * Regel: Solde caisse = Einnahmen − Sorties (registerPortion), getrennt nach Methode.
 * Implementierung: utils/liquidBalanceByChannel (+ fundingSource).
 */

export {
  computeLiquidBalanceByMethod,
  computeLiquidBalanceByChannel,
  resolveBilanLiquidBalances,
  resolveOutflowMethodKey,
  computeFinancingExposure
} from '../../utils/liquidBalanceByChannel';

/**
 * Manager/Reports-Treasury aus Liquid-Ergebnis.
 * @param {ReturnType<typeof import('../../utils/liquidBalanceByChannel').computeLiquidBalanceByMethod>|null} liquid
 */
export function summarizeTreasury(liquid) {
  return {
    treasuryBalance: Number(liquid?.total?.balance) || 0,
    treasuryBalanceCash: Number(liquid?.cash?.balance) || 0,
    treasuryBalanceElectronic: Number(liquid?.electronic?.balance) || 0,
    totalMoneyOut: Number(liquid?.total?.outgoing) || 0,
    supplierPaymentsTotal: Number(liquid?.total?.outgoingPayments) || 0,
    expenseOutTotal: Number(liquid?.total?.outgoingExpenses) || 0,
    externalFinancingTotal: Number(liquid?.total?.externalFinancing) || 0,
    openingCapitalFinancingTotal: Number(liquid?.total?.openingCapitalFinancing) || 0,
    liquidBalanceByMethod: liquid || null
  };
}
